<template>
  <v-container>
    <div>Cart Page ( coming soon... )</div>
  </v-container>
</template>

<script>
export default {
  name: 'Cart'
};
</script>
